module.exports = __webpack_public_path__ + "static/RESUME-fb800877ba6315455d49ca3dc96fa97f.pdf";